import React from "react";
import "./HomeSec4.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";

const HomeSec4 = () => {
  return (
    <div>
      <div className="container-fluid main4">
        <div className="col-12 py-3"></div>
        <div className="row k4 text-center">
          <div className="col-4"></div>
          <div className="col-4">
            <span className="p-14">OUR FACILITIES</span>
            <img className="img-114" src="./image434.webp" alt="hhh" />
          </div>
          <div className="col-4"></div>
        </div>
        <div className="container m14">
          <div className="cont-4">
            <img className="img-24" src="image147.webp" alt="hhh" />
            <div className="cont-44">
              <p className="p-24">LUSH GREEN GARDEN</p>
              <p className="p-34">
                Exploring the lush green gardens of Surya Vilas Palace is a
                journey into natural splendor and historical enchantment.
                Strolling along manicured pathways adorned with vibrant flora,
                one is transported to a bygone era of aristocratic elegance.{" "}
              </p>
            </div>
          </div>
          <div className="cont-4">
            <img className="img-24" src="image 512.webp" alt="hhh" />
            <div className="cont-44">
              <p className="p-24">SWIMMING POOL</p>
              <p className="p-34">
                Exploring the lush green gardens of Surya Vilas Palace is a
                journey into natural splendor and historical enchantment.
                Strolling along manicured pathways adorned with vibrant flora,
                one is transported to a bygone era of aristocratic elegance.{" "}
              </p>
            </div>
          </div>
          <div className="cont-4">
            <img className="img-24" src="image 511.webp" alt="hhh" />
            <div className="cont-44">
              <p className="p-24">BARADARI</p>
              <p className="p-34">
                Exploring the lush green gardens of Surya Vilas Palace is a
                journey into natural splendor and historical enchantment.
                Strolling along manicured pathways adorned with vibrant flora,
                one is transported to a bygone era of aristocratic elegance.{" "}
              </p>
            </div>
          </div>
          <div className="col-12 -flex py-2"></div>
        </div>
      </div>
      <div className="swiper-container2">
        <div className=" swiper-header">
          <span className="swiper-logo-text">OUR FACILITIES</span>
          <img className="swiper-logo-bottom" src="./image434.webp" alt="hhh" />
        </div>
        <Swiper
          modules={[Autoplay]}
          spaceBetween={50}
          slidesPerView={1}
          autoplay
        >
          <SwiperSlide>
            <div className="cont-4">
              <img className="img-24" src="image147.webp" alt="hhh" />
              <div className="cont-44">
                <p className="p-24">LUSH GREEN GARDEN</p>
                <p className="p-34">
                  Exploring the lush green gardens of Surya Vilas Palace is a
                  journey into natural splendor and historical enchantment.
                  Strolling along manicured pathways adorned with vibrant flora,
                  one is transported to a bygone era of aristocratic elegance.{" "}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="cont-4">
              <img className="img-24" src="image 512.webp" alt="hhh" />
              <div className="cont-44">
                <p className="p-24">SWIMMING POOL</p>
                <p className="p-34">
                  Exploring the lush green gardens of Surya Vilas Palace is a
                  journey into natural splendor and historical enchantment.
                  Strolling along manicured pathways adorned with vibrant flora,
                  one is transported to a bygone era of aristocratic elegance.{" "}
                </p>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="cont-4">
              <img className="img-24" src="image 511.webp" alt="hhh" />
              <div className="cont-44">
                <p className="p-24">BARADARI</p>
                <p className="p-34">
                  Exploring the lush green gardens of Surya Vilas Palace is a
                  journey into natural splendor and historical enchantment.
                  Strolling along manicured pathways adorned with vibrant flora,
                  one is transported to a bygone era of aristocratic elegance.{" "}
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default HomeSec4;
